<template>
  <span>
      {{money | smallToBig}}
  </span>
</template>
<script>

  export default {
    name: 'amount',
    props:{
        money:String
    },
    data () {
      return {
      }
    },
    async created () {
    },
    activated() {
    },
    mounted () {
    },
    watch: {
    },
    methods: {
    },
    filters: {
        smallToBig(money) {
      //  将数字金额转换为大写金额
            var cnNums = new Array(
                "零",
                "壹",
                "贰",
                "叁",
                "肆",
                "伍",
                "陆",
                "柒",
                "捌",
                "玖"
            ); //汉字的数字
            var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
            var cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
            var cnDecUnits = new Array("角", "分", "毫", "厘"); //对应小数部分单位
            var cnInteger = "整"; //整数金额时后面跟的字符
            var cnIntLast = "元"; //整数完以后的单位
            //最大处理的数字
            var maxNum = 999999999999999.9999;
            var integerNum; //金额整数部分
            var decimalNum; //金额小数部分
            //输出的中文金额字符串
            var chineseStr = "";
            var reg = /^[0-9]+.?[0-9]*$/

            // if (money == "" || money == null || money == undefined) {
            //     return "";
            // }
            money = money.toString().replace(/,/gi,'')
            money = parseFloat(money);

            if (!(reg.test(money))) {
                return ''
            } else {
                if (money< 0) {
                    return ''
                }
            }

            if (money >= maxNum) {
                //超出最大处理数字
                return "超出最大处理数字";
            }
            if (money == 0) {
                chineseStr = cnNums[0] + cnIntLast + cnInteger;
                return chineseStr;
            }
            //四舍五入保留两位小数,转换为字符串
            let moneyArr =  String(money).split('.')
            
            integerNum = moneyArr[0];
            decimalNum = moneyArr[1];
            //获取整型部分转换
            if (parseInt(integerNum, 10) > 0) {
                var zeroCount = 0;
                var IntLen = integerNum.length;
                for (var i = 0; i < IntLen; i++) {
                var n = integerNum.substr(i, 1);
                var p = IntLen - i - 1;
                var q = p / 4;
                var m = p % 4;
                if (n == "0") {
                    zeroCount++;
                } else {
                    if (zeroCount > 0) {
                    chineseStr += cnNums[0];
                    }
                    //归零
                    zeroCount = 0;
                    chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
                }
                if (m == 0 && zeroCount < 4) {
                    chineseStr += cnIntUnits[q];
                }
                }
                chineseStr += cnIntLast;
            }
            //小数部分
            if (decimalNum) {
                var decLen = decimalNum.length;
                for (var j = 0; j < decLen; j++) {
                var pi = decimalNum.substr(j, 1);
                if (pi != "0") {
                    chineseStr += cnNums[Number(pi)] + cnDecUnits[j];
                }
                }
            }
            if (chineseStr == "") {
                chineseStr += cnNums[0] + cnIntLast + cnInteger;
            } else if (decimalNum == "" || /^0*$/.test(decimalNum)) {
                chineseStr += cnInteger;
            }
            return chineseStr;
        }

    }
  }
</script>
<style lang="scss">

</style>
